import { createNotitiaUI } from "@lr-notitia/notitia-ui";
import router from "../router";

export default createNotitiaUI({
	accentColor: "#D5DB7B", // configure the accent color of the components
	router,
	theme: {
		// optional configuration of internal theme handling
		use: true, // enable notitia-ui to handle themes for you (default: true)
		persist: true, // enable notitia-ui to persist the theme in local storage (default: true)
	},
});
